export const SINOR_TRIP_GATHERING_ID = 178;
export const SINOR_TRIP_PAY_CONTENTS = 14;
export const MANUAL_MEMBERSHIP_REASON = '관리자 별도입금 확인';

export const ADMIN_PAY_CONTENT_OPTIONS = Object.freeze([
    { value: 5, label: '상품' },
    { value: 6, label: '모임' },
    { value: 7, label: '하트' },
    { value: 12, label: '79전화 이용권' },
    { value: 13, label: '켄싱턴 상품' },
    { value: SINOR_TRIP_PAY_CONTENTS, label: '시놀트립 멤버십' },
]);

const valueFrom = (object, snakeKey, camelKey) => object?.[snakeKey] ?? object?.[camelKey];

export const normalizeSinorTripProduct = (response) => {
    const data = response?.data?.data;
    const gatheringId = Number(valueFrom(data, 'gathering_id', 'gatheringId'));
    const price = Number(data?.price);

    if (!Number.isSafeInteger(gatheringId) || gatheringId <= 0 || !Number.isSafeInteger(price) || price <= 0) {
        return null;
    }

    return {
        gatheringId,
        price,
        title: data?.title || '시놀 트립 멤버십',
        gatheringName: valueFrom(data, 'gathering_name', 'gatheringName') || '시놀 트립',
    };
};

export const buildSinorTripPaymentParams = ({ product, startDate }) => ({
    pay_contents: SINOR_TRIP_PAY_CONTENTS,
    pay_amount: product.price,
    gathering_id: product.gatheringId,
    pay_name: product.title,
    start_date: startDate,
});

const isValidDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};

export const isValidSinorTripPaymentParams = (params) => {
    const gatheringId = Number(params?.gathering_id);
    const amount = Number(params?.pay_amount);
    return Number.isSafeInteger(gatheringId) && gatheringId > 0 && Number.isSafeInteger(amount) && amount > 0 && isValidDate(params?.start_date);
};

export const buildManualMembershipCompletionRequest = ({ userId, params }) => ({
    pay_contents: SINOR_TRIP_PAY_CONTENTS,
    target_user_id: Number(userId),
    gathering_id: Number(params.gathering_id),
    expected_price: Number(params.pay_amount),
    expected_no_membership: true,
    start_date: params.start_date,
    reason: MANUAL_MEMBERSHIP_REASON,
});

export const isManualMembershipCompletionResponse = (response) => {
    const payId = response?.data?.data?.pay_id;
    const membershipId = response?.data?.data?.membership_id;

    return response?.data?.ok === true && Number.isSafeInteger(payId) && payId > 0 && Number.isSafeInteger(membershipId) && membershipId > 0;
};

export const createManualMembershipIdempotencyKey = () => {
    const uuid = typeof window !== 'undefined' ? window.crypto?.randomUUID?.() : null;
    if (uuid) return `admin-membership-${uuid}`;
    return `admin-membership-${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
};
